import React from "react";
import {
  Box,
  Typography,
  Card,
  Chip,
  IconButton,
  Divider,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";

const OrderSummary = () => {
  return (
    <Box
      sx={{
        bgcolor: "#f5f5f5",
        minHeight: "100vh",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          bgcolor: "#F3DD3E",
          px: 2,
          py: 2,
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <ArrowBackIcon />
        <Typography
          sx={{
            fontSize: 18,
            fontWeight: 600,
            color: "#394867",
          }}
        >
          Order Summary
        </Typography>
      </Box>

      <Box p={2}>
        {/* Order Info */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mb: 2,
          }}
        >
          <Typography
            sx={{
              fontWeight: 700,
              color: "#4A5D7A",
              fontSize: 16,
            }}
          >
            Order ID: 3478778912346578
          </Typography>

          <Typography
            sx={{
              color: "#7D8AA5",
              fontSize: 14,
            }}
          >
            28 Apr, 10:30 AM
          </Typography>
        </Box>

        {/* Product Count */}
        <Box
          sx={{
            bgcolor: "#EEF7F2",
            borderRadius: "12px",
            p: 2,
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            mb: 2,
          }}
        >
          <Box
            sx={{
              width: 34,
              height: 34,
              borderRadius: "50%",
              bgcolor: "#D9EFE4",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Inventory2OutlinedIcon
              sx={{ color: "#547A68", fontSize: 20 }}
            />
          </Box>

          <Box>
            <Typography color="#74859E" fontSize={14}>
              Products
            </Typography>
            <Typography
              sx={{
                fontWeight: 700,
                color: "#41526F",
              }}
            >
              02 (01 Physical . 01 Digital)
            </Typography>
          </Box>
        </Box>

        {/* Physical Product Card */}
        <Card
          elevation={0}
          sx={{
            borderRadius: "18px",
            p: 2,
            mb: 2,
            border: "1px solid #E3E6EB",
          }}
        >
          <Box display="flex" justifyContent="space-between">
            <Box display="flex" gap={2}>
              <Box
                component="img"
                src="https://upload.wikimedia.org/wikipedia/en/thumb/0/05/Snickers-Small.jpg/250px-Snickers-Small.jpg"
                sx={{
                  width: 68,
                  height: 48,
                  objectFit: "contain",
                }}
              />

              <Box>
                <Typography
                  sx={{
                    fontSize: 16,
                    fontWeight: 700,
                    color: "#42567A",
                  }}
                >
                  Snickers Chocolate
                </Typography>

                <Typography
                  sx={{
                    color: "#6E7D96",
                    fontWeight: 600,
                    mt: 0.5,
                  }}
                >
                  1 Items
                </Typography>

                <Box
                  display="flex"
                  alignItems="center"
                  gap={0.5}
                  mt={0.8}
                >
                  <CheckCircleIcon
                    sx={{
                      color: "#00B66A",
                      fontSize: 18,
                    }}
                  />
                  <Typography
                    sx={{
                      color: "#00B66A",
                      fontWeight: 500,
                      fontSize: 14,
                    }}
                  >
                    Pickup Completed
                  </Typography>
                </Box>
              </Box>
            </Box>

            <Typography
              sx={{
                color: "#00B66A",
                fontWeight: 700,
                fontSize: 22,
              }}
            >
              ₹20.00
            </Typography>
          </Box>

          <Box
            sx={{
              mt: 2,
              bgcolor: "#F0F8F4",
              borderRadius: "10px",
              p: 2,
            }}
          >
            <Box display="flex" gap={1}>
              <LocationOnOutlinedIcon
                sx={{
                  color: "#75839A",
                  fontSize: 20,
                  mt: 0.3,
                }}
              />

              <Box>
                <Typography
                  sx={{
                    color: "#75839A",
                    fontWeight: 600,
                    fontSize: 14,
                  }}
                >
                  Pickup Location
                </Typography>

                <Typography
                  sx={{
                    fontWeight: 700,
                    color: "#4A5D7A",
                    mt: 0.5,
                  }}
                >
                  Samsung Pvt. Ltd.
                </Typography>

                <Typography
                  sx={{
                    color: "#9AA6B8",
                    fontSize: 14,
                  }}
                >
                  Floor 2 · Plot 2, sector-18, Noida
                </Typography>
              </Box>
            </Box>
          </Box>
        </Card>

        {/* Digital Product Card */}
        <Card
          elevation={0}
          sx={{
            borderRadius: "18px",
            p: 2,
            border: "1px solid #E3E6EB",
            mb: 2,
          }}
        >
          <Box display="flex" justifyContent="space-between">
            <Box display="flex" gap={2}>
              <Box
                sx={{
                  width: 68,
                  height: 42,
                  borderRadius: "6px",
                  bgcolor: "#FF8C1A",
                  transform: "rotate(-8deg)",
                }}
              />

              <Box>
                <Chip
                  label="Digital"
                  size="small"
                  sx={{
                    bgcolor: "#F3E8FF",
                    color: "#8B5CF6",
                    mb: 1,
                  }}
                />

                <Typography
                  sx={{
                    fontWeight: 700,
                    color: "#42567A",
                    fontSize: 16,
                  }}
                >
                  Myntra Gift Card
                </Typography>

                <Typography
                  sx={{
                    color: "#6E7D96",
                    fontWeight: 600,
                    mt: 0.5,
                  }}
                >
                  1 Items
                </Typography>

                <Box display="flex" gap={0.5} mt={1}>
                  <CheckCircleIcon
                    sx={{
                      color: "#8B5CF6",
                      fontSize: 18,
                    }}
                  />
                  <Typography
                    sx={{
                      color: "#8B5CF6",
                      fontSize: 14,
                    }}
                  >
                    Email Delivery
                  </Typography>
                </Box>
              </Box>
            </Box>

            <Box textAlign="right">
              <IconButton
                sx={{
                  border: "2px solid #8B5CF6",
                  width: 32,
                  height: 32,
                  mb: 2,
                }}
              >
                <KeyboardArrowRightIcon sx={{ color: "#8B5CF6" }} />
              </IconButton>

              <Typography
                sx={{
                  color: "#00B66A",
                  fontWeight: 700,
                  fontSize: 22,
                }}
              >
                Free
              </Typography>
            </Box>
          </Box>
        </Card>

        {/* Grand Total */}
        <Card
          elevation={0}
          sx={{
            borderRadius: "16px",
            border: "1px solid #E3E6EB",
            p: 2,
          }}
        >
          <Box display="flex" justifyContent="space-between">
            <Typography
              sx={{
                fontWeight: 700,
                color: "#42567A",
                fontSize: 18,
              }}
            >
              Grand Total
            </Typography>

            <Typography
              sx={{
                fontWeight: 700,
                color: "#42567A",
                fontSize: 18,
              }}
            >
              ₹20.00
            </Typography>
          </Box>
        </Card>
      </Box>
    </Box>
  );
};

export default OrderSummary;